import { ActionTree } from 'vuex'

import {
  submitPromoCode,
  validatePromoCode,
} from '@/sdk/clients/PromotionsClient'
import { RootState } from '@/store/types'

import { Mutations, PromotionsState } from './types'

const actions: ActionTree<PromotionsState, RootState> = {
  async validatePromoCode({ commit }, promoCode: string) {
    const boolResponse = await validatePromoCode(promoCode)

    commit(Mutations.SET_IS_PROMO_CODE_VALID, boolResponse)
  },

  async submitPromoCode({ rootState }, promoCode: string) {
    if (!promoCode) {
      return
    }

    const service_request_draft_id =
      rootState.registration.serviceRequestDraftId

    const payload = {
      service_request_draft_id,
      promotion_code: promoCode,
    }

    await submitPromoCode(payload)
  },
}

export default actions
